import { render, staticRenderFns } from "./WsExpertsListDetails.vue?vue&type=template&id=50e9ec24&scoped=true"
import script from "./WsExpertsListDetails.vue?vue&type=script&lang=js"
export * from "./WsExpertsListDetails.vue?vue&type=script&lang=js"
import style0 from "./WsExpertsListDetails.vue?vue&type=style&index=0&id=50e9ec24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9ec24",
  null
  
)

export default component.exports